import Demo from '../pages/demo.vue'

export const createSiteRouter = async () => {

  const siteProfile = `${__SITE_PROFILE__}`

  return [{
      path: '/',
      name: 'Home',
      component: () => import(`../pages/home/${siteProfile}.vue`)
    },
    
    {
      path: '/demo',
      name: 'Demo',
      component: Demo
    },
    {
      path: '/courses',
      name: 'European',
      component: () => import(`../pages/courses/${siteProfile}.vue`)
    },
    {
      path: '/courses/migrate',
      name: 'migrate',
      component: () => import(`../pages/courses/migrate/${siteProfile}.vue`)
    },
    {
      path: '/courses/child',
      name: 'child',
      component: () => import(`../pages/courses/child/${siteProfile}.vue`)
    },
    {
      path: '/courses/teenager',
      name: 'teenager',
      component: () => import(`../pages/courses/teenager/${siteProfile}.vue`)
    },
    {
      path: '/teachers',
      name: 'teacher',
      component: () => import(`../pages/teachers/${siteProfile}.vue`)
    },
    {
      path: '/help/classroom',
      name: 'help',
      component: () => import(`../pages/help/classroom.vue`)
    },
    {
      path: '/training',
      name: 'training',
      component: () => import(`../pages/training/index.vue`)
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('../pages/NotFound.vue')
    }
  ]

}